import { useForm } from "antd/es/form/Form";
import { useEditMember } from "services/rest/member";
import { Button, Col, Form, Input, Modal, notification, Row } from "antd";
import React from "react";
import { useIntl } from "react-intl";
import { RoleSelect } from "components/role-select/RoleSelect";
import { IMember } from "components/team-member/TeamMember";

export type EditUserModalProps = {
  member: IMember,
  visible: boolean,
  onAfterOk: () => void,
  onCancel: () => void
}

export function EditUserModal(props: EditUserModalProps) {
  const { member, visible, onAfterOk, onCancel } = props;
  const intl = useIntl();
  const [form] = useForm();
  const { loading, fetch } = useEditMember(member.id);

  form.setFieldsValue({ ...member });

  const editUser = () => {
    fetch(form.getFieldsValue())
      .then(() => {
        notification.success({
          message: intl.formatMessage({ id: "jmix-store.edit-user-modal.success" }),
          placement: "bottomLeft",
        });

        onCancel();
        onAfterOk();
      })
      .catch(() => notification.error({
        message: intl.formatMessage({ id: "jmix-store.edit-user-modal.error" }),
        placement: "bottomLeft",
      }));
  };

  const footers: React.ReactNode = (
    <Row
      justify="end"
      gutter={[16, 16]}
    >
      <Col>
        <Button
          ghost
          type="primary"
          onClick={onCancel}
        >
          {intl.formatMessage({ id: "jmix-store.modal.action.cancel" })}
        </Button>
      </Col>
      <Col>
        <Button
          type="primary"
          loading={loading}
          onClick={editUser}
        >
          {intl.formatMessage({ id: "jmix-store.billing-info.save-button" })}
        </Button>
      </Col>
    </Row>
  );

  return (
    <Modal
      title={intl.formatMessage({ id: "jmix-store.edit-user-modal.title" })}
      visible={visible}
      centered
      className="team-member__add-user-modal"
      destroyOnClose
      onCancel={onCancel}
      footer={footers}
    >
      <Form
        layout="vertical"
        form={form}
      >
        <Form.Item
          label={intl.formatMessage({ id: "jmix-store.team-member.column.email" })}
          name="email"
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "jmix-store.company-billing-info.email.rule-message_1" }),
            }]
          }
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({ id: "jmix-store.team-member.column.role" })}
          name="role"
          // tooltip={<RoleDescription />}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "jmix-store.team-member.role.rule-message" }),
            }]
          }
        >
          <RoleSelect />
        </Form.Item>
      </Form>
    </Modal>
  );
}